import { useMutation, useQuery } from "@apollo/client/react"; import React, { useMemo, useState } from 'react';

import DoneIcon from "@mui/icons-material/Done";
import ListaCondiciones from './ListaCondiciones';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { GrillaHonorario } from './GrillaHonorarios';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { GET_ERRORES_BY_VISITA } from '../../../data/graphQL/queries/MisVisitas/getErroresByVisita';
import RECHAZAR_VISITA from '../../../data/graphQL/mutations/ControlVisita/rechazarVisita';
import ANULAR_VISITA from '../../../data/graphQL/mutations/ControlVisita/anularVisita';
import toast from 'react-hot-toast';
import APROBAR_VALIDACION from '../../../data/graphQL/mutations/Visitas/saveAprobarValidacion';

export const ValidarModal = ({ visita, reload, idTipoProfesional }) => {
  const [openModal, setOpenModal] = useState(false);
  const [openModalSecondary, setOpenModalSecondary] = useState(false);
  const [esRechazo, setEsRechazo] = useState(false);
  //los importes estan a esta altura y no en el componente de grilla honorario porque en este componente
  //padre es que se va a ejecutar el handleAccept que ejecutara la mutation donde se guarda VisitaHonorario
  const [importes, setImportes] = useState({});
  const [observacion, setObservacion] = useState('');

  const { data } = useQuery(GET_ERRORES_BY_VISITA, {
    variables: { idVisita: visita?.idVisita },
    fetchPolicy: "network-only"
  });

  const [aprobarValidacion, { loading: aprobarLoading }] = useMutation(APROBAR_VALIDACION, {
    variables: {
      input: {
        idVisita: visita.idVisita,
        presencial: importes.presencial,
        virtual: importes.virtual,
        tramo: importes.tramo,
        cambioSonda: importes.cambioSonda,
        capacitacion: importes.capacitacion,
        emergencia: importes.emergencia,
        extraDuracion: importes.extraDuracion,
        importeTotal: importes.importeTotal
      }
    }
  });

  const [rechazarVisita, { loading: rechazarLoading }] = useMutation(RECHAZAR_VISITA, {
    fetchPolicy: 'no-cache',
    variables: {
      input: {
        idVisita: visita.idVisita,
        presencial: importes.presencial,
        virtual: importes.virtual,
        tramo: importes.tramo,
        cambioSonda: importes.cambioSonda,
        capacitacion: importes.capacitacion,
        emergencia: importes.emergencia,
        extraDuracion: importes.extraDuracion,
        importeTotal: importes.importeTotal
      },
      idVisita: visita?.idVisita,
      observacion
    }
  });

  const [anularVisita, { loading: anularLoading }] = useMutation(ANULAR_VISITA, {
    fetchPolicy: 'no-cache',
    variables: { idVisita: visita?.idVisita, observacion }
  });

  const handleOpenModal = () => setOpenModal(true);

  const handleOpenModalSecondary = (esRechazo) => {
    setEsRechazo(esRechazo);
    setOpenModalSecondary(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCloseModalSecondary = () => {
    setOpenModalSecondary(false);
    setObservacion('');
  };

  const handleAccept = () => {
    aprobarValidacion().then(() => {
      toast.success('Visita validada correctamente.');
      reload();
      handleCloseModal();
    });
  };

  const handleAcceptRechazar = () => {
    toast.promise(rechazarVisita().then(() => {
      reload();
      handleCloseModal();
    }), {
      loading: 'Rechazando visita...',
      success: 'Visita rechazada.',
      error: 'Ocurrió un error al intentar rechazar la visita.'
    });

  };

  const handleAcceptAnular = () => {
    toast.promise(anularVisita(), {
      loading: 'Anulando visita...',
      success: 'Visita anulada.',
      error: 'Ocurrió un error al intentar anular la visita.'
    });
    handleCloseModal();
  };

  const buttonLoading = useMemo(() => rechazarLoading || anularLoading || aprobarLoading, [anularLoading, rechazarLoading, aprobarLoading]);

  return <>
    <div aria-hidden='true' onClick={() => handleOpenModal()} className='item-option clickable-option'>
      <DoneIcon className='edit-icon' />
      <span className='toggle-action'>Validar</span>
    </div>
    <CustomDialog
      maxWidth="md"
      fullWidth={true}
      open={openModalSecondary}
      title={esRechazo ? 'Rechazar Visita' : 'Anular Visita'}
      acceptLoading={buttonLoading}
      cancelLoading={buttonLoading}
      onCancel={handleCloseModalSecondary}
      acceptText='Aceptar'
      onAccept={esRechazo ? handleAcceptRechazar : () => { }}
      cancelText='Cancelar'>

      <RenderInputByTypeMobile
        input={{
          name: 'observacion',
          type: 'long_string',
          displayName: 'Justificación'
        }}
        value={observacion}
        handleChange={(name, value) => setObservacion(value)} />

    </CustomDialog>
    <CustomDialog
      maxWidth="md"
      fullWidth={true}
      open={openModal}
      acceptLoading={buttonLoading}
      title={'Validación de Visita'}
      onAccept={handleAccept}
      onCancel={handleCloseModal}
      acceptText='Aprobar'
      customActionsDirection={'center'}
      customActions={
        <>
          <CustomButton
            onClick={() => handleOpenModalSecondary(true)}
            size='small'
            variant='outlined'
            isLoading={buttonLoading}
            disabled={buttonLoading}>

            Rechazar
          </CustomButton>
        </>
      }>

      <GrillaHonorario visita={visita} setImportes={setImportes} idTipoProfesional={idTipoProfesional} />
      {data?.erroresByVisita?.length > 0 && <ListaCondiciones items={data?.erroresByVisita ?? []} />}
    </CustomDialog>
  </>;
};